export default __webpack_public_path__ + "static/media/education.a8f6099a.jpg";